import { Link } from "react-router-dom";
import { DexxTableTitle } from "../HeaderButton";
import { DexxButton } from "../light/LightButton";
import { DexxTable } from "../light/LightTable";

export function addBtns(row: any[], btnLabels: string[], btnUrls: string[], uuid: any) {
    let tmp = btnLabels.map((b, i) => {
        return <div><TableButton label={b} link={btnUrls[i] + uuid} key={i} /></div>
    })
    return [...row, ...tmp]
}

export function DashboardTab(props: {
    active: boolean, label: string,
    headers: any[], rows: any[], onClick?: Function, dark?: boolean
}): JSX.Element {
    const active = props.active && props.rows.length > 0
    return <>
        <DexxTableTitle label={props.label + " (" + props.rows.length + ")"}
            active={active} onClick={props.onClick}
            className={"pl-8 md:pl-16 " + (props.dark ? " bg-dark_blue_lighter " : "")} />
        {active ?
            <DexxTable headers={props.headers} rows={props.rows} alignment={[]} /> : <></>
        }
    </>
}

export function Filter(props: { label: string, checked: boolean, setFunction: Function }): JSX.Element {
    return <>
        <div className={"col-span-4 font-urbanist py-2 tracking-wider"}>
            <label className="w-full text-white uppercase text-sm py-4">
                <input type="checkbox" checked={props.checked} className={"mr-4"}
                    onChange={() => props.setFunction(!props.checked)} />
                {props.label}
            </label>
        </div>
    </>
}

export function TableButton(props: { label: string, link: string }): JSX.Element {
    return <>
        <Link className="grid justify-center" to={props.link}>
            <DexxButton label={props.label} className="rounded-lg m-1 font-normal px-2" color1="primary" color2="primary" color3="primary_lightest" />
        </Link>
    </>
}